import { render, staticRenderFns } from "./ToastNotification.vue?vue&type=template&id=2b50611a&"
import script from "./ToastNotification.vue?vue&type=script&lang=ts&"
export * from "./ToastNotification.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports